import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'

import '../assets/style/main.css'

import { PrivateRoutes } from './PrivateRoutes'
import { PublicRoutes } from './PublicRoutes'

// import { IndexHome } from '../components/home/IndexHome';
import { Login } from '../components/login/login'
import { DashboardRoutes } from './DashboardRoutes'
import { ModalProgress } from '../components/modals/ModalProgress'
import { startCheking, startLogin } from '../redux/actions/auth'
import { RecoverPassword } from './../components/recoverPassword/RecoverPassword'
import { RecoverPasswordTwo } from './../components/recoverPassword/RecoverPasswordTwo'
import { MessageRecoverPassword } from './../components/recoverPassword/MessageRecoverPassword'
import { Onboarding } from '../components/onboarding/Onboarding'
import { OnboardingSignup } from '../components/onboarding/OnboardingSignup'
import InstallPWA from '../components/InstallPWA'

export const App = () => {

  const location = useLocation();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { checking, uid, perfil } = useSelector(state => state.auth);

  const isExplore = location.pathname === "/explore";

  /* console.log("PATH:", location.pathname);
  console.log("UID:", uid);
  console.log("CHECKING:", checking); */

  useEffect(() => {
    if (isExplore) {
      const form = {
        email: 'demo@pretzu.com',
        password: 'pretzu2023'
      };

      dispatch(startLogin(form.email, form.password));
      navigate('/login');
    }
  }, [isExplore, dispatch, navigate]);


  useEffect(() => {
    dispatch(startCheking());
  }, [dispatch])

  /* useEffect(() => {
    console.log("CAMBIO AUTH:", {
      path: location.pathname,
      checking,
      uid
    });
  }, [location.pathname, checking, uid]); */

  if (checking) {
    return (
      <ModalProgress />
    );
  }

  return (
    // <BrowserRouter>

    <>

      <Routes>

        {/* <Route path='/' element={<IndexHome />} /> */}

        <Route path='/password/reset' element={
          <RecoverPassword />
        } />

        <Route path='/password/reset/confirm/:requestId' element={
          <RecoverPasswordTwo />
        } />

        <Route path='/mensaje' element={
          <MessageRecoverPassword />
        } />

        {/* <Route path='/explore' element={
        <DashboardRoutes />
      } /> */}

        {/* valida email y codigo de registro */}
        <Route path='/onboarding' element={
          <Onboarding />
        } />

        {/* crea cuenta */}
        <Route path='/onboarding/signup' element={
          <OnboardingSignup />
        } />

        <Route path='/login' element={
          <PublicRoutes isAuth={!!uid} perfil={perfil}>
            <Login />
          </PublicRoutes>
        } />

        <Route path="/*" element={
          <PrivateRoutes isAuth={!!uid}>
            <DashboardRoutes />
          </PrivateRoutes>
        } />

      </Routes>

      <InstallPWA />  {/* ← aquí */}

    </>

    // </BrowserRouter>
  );
};
